import { z } from 'zod';

import { DOCUMENT_STATUSES } from '@/lib/document-status';

// Contrato del panorama de impacto (GET /master-list/:id/impact), validado con Zod.

export const RELATION_TYPES = ['relacionado', 'impacta'] as const;
export type RelationType = (typeof RELATION_TYPES)[number];
export type RelationDirection = 'outgoing' | 'incoming';

export const impactRowSchema = z.object({
  entryId: z.string(),
  code: z.string(),
  title: z.string().nullable(),
  status: z.enum(DOCUMENT_STATUSES),
  relationType: z.enum(RELATION_TYPES),
  direction: z.enum(['outgoing', 'incoming']),
});
export type ImpactRow = z.infer<typeof impactRowSchema>;

export const impactResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(impactRowSchema),
});
